import Vue from "vue";
import ElementUI from "element-ui";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import messages from "./assets/i18n";
import { initTrack } from "yl-track";
import "./assets/css/iconfont.css";
import "./assets/iconfont/eyes/iconfont.css"; // 补充
import "./assets/css/element-variables.scss";
import { trackInit, trackLogin, vueErrorHandler } from "@/utils/track";

Vue.config.productionTip = false;

Vue.prototype.$Captcha = window.initCaptcha({
  appKey: "189934313",
});

Vue.use(VueI18n);
Vue.use(ElementUI, { locale: messages[store.state.base.lang] });

trackInit();

// 已登录用户刷新页面后，恢复 SDK 的登录状态
const userInfo = localStorage.getItem("userInfo");
if (userInfo) {
  try {
    const { id } = JSON.parse(userInfo);
    if (id) trackLogin(id);
  } catch (e) {
    console.error(e);
  }
}

initTrack({
  pid: "official-br", // 注意：在埋点数据管理中，找到应用管理，将此pid替换成项目编码
});

const i18n = new VueI18n({
  locale: store.state.base.lang || "pt-br", // 设置语言  pt-br | en-us | zh-cn
  messages: messages, // 语言包
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

vueErrorHandler(Vue);
